import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

import { SubmittableSecuritySettings } from '../Setting/utils/Helper';

type UpdateSettingsState = {
    isLoading: boolean
};

type Meta = SecurityUpdateSettingsConnection['meta'];
type Payload = SecurityUpdateSettingsConnection['payload'];

/**
 * セキュリティ設定全体 更新フック
 * control/security/setting エンドポイントへ POST する
 */
export const useUpdateSettings = (
    successCallback: (meta: Meta, payload: Payload) => void = () => undefined,
    failureCallback: (meta: Meta, payload: Payload) => void = () => undefined,
) => {
    const [state, setState] = useState<UpdateSettingsState>({
        isLoading: false,
    });

    const securityUpdateSettingsConnection = useAppSelector(state => state.securityUpdateSettingsConnection);

    const dispatch = useDispatch();

    useEffect(() => {
        const { meta, payload } = securityUpdateSettingsConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                successCallback(meta, payload);
                setState(prev => ({ ...prev, isLoading: false }));
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                failureCallback(meta, payload);
                setState(prev => ({ ...prev, isLoading: false }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [securityUpdateSettingsConnection]);

    const request = useCallback((data: SubmittableSecuritySettings) => {
        dispatch(Actions.http.connection.security.updateSettings(data));
        setState(prev => ({ ...prev, isLoading: true }));
    }, [dispatch]);

    return [state, request] as const;
};
